import styled from 'styled-components';

const Container = styled.div`
  position: absolute;
  right: 0;
  top: -4px;
`;

export default Container;
